export const applyCode = {
  applying: 0, //审批中
  passed: 1, //审批通过
  reject: 2, //审批驳回
  expired: 3 //审批过期
}

export const applyStatusName  = {
  [applyCode.passed]: '已通过',
  [applyCode.reject]: '已拒绝',
  [applyCode.expired]: '已过期'
}